/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Type of catalog item within its category.
 */
export enum CatalogItemType {
  CatalogItemTypeOS = 'os',
  CatalogItemTypeFirmware = 'firmware',
  CatalogItemTypeDriver = 'driver',
  CatalogItemTypeContainer = 'container',
  CatalogItemTypeHelm = 'helm',
  CatalogItemTypeQuadlet = 'quadlet',
  CatalogItemTypeCompose = 'compose',
  CatalogItemTypeData = 'data',
}
